import { createSelector } from 'reselect'
import { getSelectedLangCode } from './lang'
import { translateDoc } from './common'

export const getTheme = createSelector(
  state => state.themeDetail.data,
  getSelectedLangCode,
  (theme, langCode) => theme === null ? null : translateDoc(theme, langCode)
)
